import Vue from 'vue';
import Router from 'vue-router';
import storage from '@/utils/localstorage';

const config = require('../../config');

Vue.use(Router);
// 解决多次点击重复路由报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const constRouter = [
  {
    path: '/',
    component: () => import('@/views/Ydzy'),
    meta: {
      title: 'APP下载'
    }
  // }, {
  //   path: '/list',
  //   component: () => import('@/views/app'),
  //   meta: {
  //     title: '应用列表'
  //   }
  // }, {
  //   path: '/search',
  //   component: () => import('@/views/app/Search'),
  //   meta: {
  //     title: '搜索'
  //   }
  // }, {
  //   path: '/detail/:key',
  //   component: () => import('@/views/app/Detail'),
  //   meta: {
  //     title: '详情'
  //   }
  }
];

const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production'
    ? config.build.assetsPublicPath
    : config.dev.assetsPublicPath,
  scrollBehavior: (to, from, savedPosition) => {
    return {x: 0, y: 0};
  },
  routes: constRouter
});

const whiteList = ['/login', '/register'];

let asyncRouter;

// 导航守卫，渲染动态路由
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.path === '/list') {
    to.meta.keepAlive = from.path !== '/search';
  }
  if (whiteList.indexOf(to.path) !== -1) {
    next();
  } else {
    next();
  }
});

router.afterEach(() => {
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js